/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactResponse } from '../models/ContactResponse';
import type { NewsletterPost } from '../models/NewsletterPost';
import type { NewsletterResponse } from '../models/NewsletterResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NewsletterService {

    /**
     * Return all newsletter
     * Return all newsletter
     * @returns NewsletterResponse Successful Response
     * @throws ApiError
     */
    public static returnAllNewsletter(): CancelablePromise<NewsletterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/newsletter/all-newsletter',
        });
    }

    /**
     * Add newsletter
     * Add newsletter
     * @param requestBody
     * @returns NewsletterResponse Successful Response
     * @throws ApiError
     */
    public static addNewsletter(
        requestBody: NewsletterPost,
    ): CancelablePromise<NewsletterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/newsletter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete newsletter
     * Delete newsletter
     * @param idNewsletter
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static deleteNewsletter(
        idNewsletter: string,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/newsletter/delete-newsletter',
            query: {
                'id_newsletter': idNewsletter,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
